<template>
  <div class="loading_wrapper" v-show="isShowLoading">
    <div class="loading"></div>
  </div>
</template>
<script>
export default {
  name: "Loading",
  data() {
    return {
      title: "loading...",
      isShowLoading: false,
    };
  },
  methods: {
    show(title) {
      this.isShowLoading = true;
      if (title) {
        this.title = title;
      }
    },
    hide() {
      this.isShowLoading = false;
    },
  },
};
</script>
<style lang="less" scoped>
.loading_wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 0.18rem;
  color: #fff;
  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 6px;
    height: 10px;
    animation: rectangle infinite 1s ease-in-out -0.2s;
    background-color: #000;
  }

  .loading:before,
  .loading:after {
    position: absolute;
    width: 6px;
    height: 10px;
    content: "";
    background-color: #000;
  }

  .loading:before {
    left: -14px;
    animation: rectangle infinite 1s ease-in-out -0.4s;
  }

  .loading:after {
    right: -14px;
    animation: rectangle infinite 1s ease-in-out;
  }

  @keyframes rectangle {
    0%,
    80%,
    100% {
      height: 20px;
      box-shadow: 0 0 rgb(0, 0, 0);
    }

    40% {
      height: 30px;
      box-shadow: 0 -20px #000;
    }
  }
}
</style>

